import "./List.css";

import { PlusIcon } from "src/assets";

import { OrganisationTypeConstants } from "../../../../constants";
import { Button, Column, CursorDataGrid, Row } from "../../../../widget";
import { AddEditCompanyModal } from "../panels/AddEditCompanyModal";
import { CompanyDetailsModal } from "../panels/CompanyDetailsModal";
import { useList } from "./useList";

export const List = (): JSX.Element => {
  const {
    dataGridColumns,
    isLoading,
    onAddCompanyClick,
    onCloseAddEditCompanyModal,
    onCloseCompanyDetailsModal,
    onEditCompanyClick,
    onDataGridChange,
    onCompanySaved,
    onCompanyDeleted,
    fetchCompanyByUuid,
    refreshCompaniesGrid,
    selectedCompanyUuid,
    showCompanyDetailsModal,
    companyFormMode,
    showAddEditCompanyModal,
    currentUserType,
  } = useList();

  return (
    <div className="TemplateTabCard OperationsCompaniesCard">
      <Row spacingV="m">
        <Column span={12}>
          <div className="OperationsCompaniesHeader">
            <h2>Companies</h2>
            <Button
              text="Add company"
              onClick={onAddCompanyClick}
              corners={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "rounded" : "default"}
              size="small"
              icon={<PlusIcon />}
              iconPosition="left"
            />
          </div>
        </Column>
      </Row>
      <CursorDataGrid
        columns={dataGridColumns}
        clientSide={false}
        filterable
        onChange={onDataGridChange}
        data={[]}
        dataIsLoading={isLoading}
        noDataMessage="No companies to display"
        variant={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "seed" : "default"}
        refresh={refreshCompaniesGrid}
      />
      <AddEditCompanyModal
        show={showAddEditCompanyModal}
        onClose={onCloseAddEditCompanyModal}
        onSaved={onCompanySaved}
        mode={companyFormMode}
        companyUuid={selectedCompanyUuid}
        fetchCompanyByUuid={fetchCompanyByUuid}
      />
      <CompanyDetailsModal
        show={showCompanyDetailsModal}
        onClose={onCloseCompanyDetailsModal}
        companyUuid={selectedCompanyUuid}
        fetchCompanyByUuid={fetchCompanyByUuid}
        onEdit={onEditCompanyClick}
        onDeleted={onCompanyDeleted}
      />
    </div>
  );
};
